export default __webpack_public_path__ + "static/media/fog-low.701e1080.png";